// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".badge.badge-pill[data-v-48cbb4fe]{height:2rem;display:inline-flex;align-items:center}.header-container[data-v-48cbb4fe]{padding-left:1em;max-width:none}[data-v-48cbb4fe] .router-link-active,[data-v-48cbb4fe] .router-link-exact-active{border-bottom:2px solid #c7d121!important;color:#c7d121!important;font-weight:700}.row[data-v-48cbb4fe]{margin-left:0;margin-right:0}", ""]);
// Exports
module.exports = exports;
